import { NgForm } from "@angular/forms";
import { Supplier } from "../../../all-models";
import { SharedDataService } from "../../../Services/shared-data/shared-data.service";

export class SaveStepParam {

    constructor(
        public sharedDataSvc: SharedDataService
        ) { }

    public step: number;
    public nextAction: string;
    public supplier: Supplier;

    private _canSave:boolean = null;

    public get canSave(): boolean{
        return this._canSave
    }
    public set canSave(value:boolean){
        if (this._canSave!=value){
            if (value != null){
                //this.sharedDataSvc.WindowUnlock();
                this._canSave = value;
            }
        }
    }

    public nextStep: number;
    public f: NgForm
    public noSaveAllowed(currentStep: number): boolean {
        return this.nextAction == 'close'
            || this.nextAction == 'previous'
            || (this.nextAction == 'forceScreen' && this.nextStep != currentStep);
    };
    public Comment: string;
}

